module.exports = __webpack_public_path__ + "img/air-china.a0b8f275.jpg";